import Box from '@redbubble/design-system/src/Box';
import * as constants from '@redbubble/design-system/src/constants';
import Image from 'next/legacy/image';
import React from 'react';
import styles from './FavoriteIcon.module.scss';
import heartFilled from './heart-filled.svg';
import heartOutline from './heart-outline.svg';

export interface FavoriteIconProps {
  favorited?: boolean;
  size: string;
}

export const FavoriteIcon: React.FC<FavoriteIconProps> = ({
  favorited,
  size,
}) => {
  const imageSrc = favorited ? heartFilled : heartOutline;

  return (
    <Box
      element="span"
      data-testid="favourite-icon"
      className={styles.container}
    >
      <Box
        element="span"
        padding="s"
        className={[styles.icon, favorited && styles.favorited]
          .filter(Boolean)
          .join(' ')}
      >
        <Box
          element="span"
          className={[
            styles.imageWrapper,
            size === constants.SMALL && styles.small,
          ].join(' ')}
        >
          <Image
            data-testid={`favourite-icon-${favorited ? 'remove' : 'add'}`}
            className={styles.image}
            src={imageSrc}
            layout="responsive"
            // a11y handled by button this is within
            alt=""
          />
        </Box>
      </Box>
    </Box>
  );
};
